<template>
  <div class="act-video" :style="info.css" @click.prevent="start_play($event,false)">
    <div class="poster" :style="coverStyle" v-if="show_cover">
      <div class="play_btn" :style="playBtnStyle"></div>
    </div>
    <div class="video" ref="video"></div>
  </div>
</template>

<script>
export default {
  name: "ActVideo",
  props: {
    info: {
      type: Object,
      default: function() {
        return {
          v_vid: "",
          v_poster: "",
          v_autoplay: false,
          v_play_btn: "https://act.mgtv.com/h5/t21/assets/images/play.png"
        };
      }
    }
  },
  data() {
    return {
      player: null,
      show_cover: true
    };
  },
  methods: {
    wait_player() {
      return new Promise((resolve, reject) => {
        if (window.ZTMobilePlayer) {
          return resolve();
        }
        clearInterval(this.check_interval);
        this.check_interval = null;
        this.check_interval = setInterval(() => {
          if (window.ZTMobilePlayer) {
            clearInterval(this.check_interval);
            return resolve();
          }
        }, 100);
      });
    },
    _init_and_play(auto_play) {
      //首次播放
      if (this.player) {
        return;
      }
      this.show_cover = false;

      this.player = new ZTMobilePlayer({
        ch: gact.cxid || "", //渠道ID
        wrapper: this.$refs.video, //必填 播放器容器
        autoplay: true, //可选,默认自动播放
        muted: auto_play ? true : null, //是否静音
        controls: true,
        loop: true,
        controltype: 1, //自带UI
        x5VideoPlayerType: "h5" //'h5':启用同层播放,在Android微信下会自动弹出播放 '':为空不启用同层播放,在Android下微信会被覆盖自定义ui,但是不会弹出播放 默认为空，不开启x5内核浏览器同层
        // themeColor:"#4787ed" //可选,主题色选择.默认#ff5f00
      });
      this.player.fetchVideoInfo(this.info.v_vid + "");
    },
    start_play(e, auto_play) {
      this.wait_player().then(() => {
        this._init_and_play(auto_play);
      });
    }
  },
  computed: {
    coverStyle() {
      return {
        background: `url(${this.info.v_poster}) 0% 0% / cover no-repeat`
      };
    },
    playBtnStyle() {
      return {
        background: `url(${this.info.v_play_btn}) 0% 0% / cover no-repeat`
      };
    }
  },
  mounted() {
    setTimeout(() => {
      if (this.info.v_autoplay) {
        this.start_play(null, true);
      }
    }, 1500);
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="stylus" scoped>
  @import "../../../share/mixins.styl"
  .act-video
    position relative
    width 6rem
    height 3.375rem
    margin 0 auto
    .poster
      width 100%
      height 100%
      center()
      z-index 1
    .play_btn
      center()
      width 1.28rem
      height 1.28rem
      z-index 2
    .video
      width 100%
      height 100%
</style>
